import React from 'react';

export const RawTransactionsPanel = ({ loading, data, workday }) => (
  <div className="flex flex-col min-h-0 h-full">
    <div className="px-4 py-2 bg-gray-50 border-b border-gray-100 flex-shrink-0">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Raw Transactions</p>
      <p className="text-xs text-gray-400">{workday} ± 1 day</p>
    </div>
    <div className="overflow-y-auto flex-1">
      {loading ? (
        <div className="p-6 text-center text-gray-400 text-sm">Loading...</div>
      ) : !data || data.length === 0 ? (
        <div className="p-6 text-center text-gray-400 text-sm">No raw transactions found.</div>
      ) : (
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              {['Date', 'Time', 'Door', 'Card'].map(h => (
                <th key={h} className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map((t, i) => (
              <tr key={i} className={`hover:bg-gray-50 ${t.transdate === workday ? 'bg-blue-50' : ''}`}>
                <td className="px-3 py-2 whitespace-nowrap text-gray-700">{t.transdate}</td>
                <td className="px-3 py-2 whitespace-nowrap font-mono text-gray-900">{t.transtime}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-600">{t.door_code}</td>
                <td className="px-3 py-2 whitespace-nowrap text-gray-400 text-xs">{t.card_no}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </div>
);

const LABELS = {
  clock_in: 'Clock In', clock_out: 'Clock Out',
  shift_id: 'Shift', is_final: 'Finalized',
  is_overridden: 'Excused', override_remark: 'Excuse Remark',
};

const fmtVal = (key, val) => {
  if (val === null || val === undefined) return '—';
  if (key === 'clock_in' || key === 'clock_out') {
    const d = new Date(val);
    return isNaN(d) ? val : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }
  if (typeof val === 'boolean') return val ? 'Yes' : 'No';
  return String(val);
};

export const AuditTrailPanel = ({ loading, data }) => (
  <div className="flex flex-col min-h-0 h-full">
    <div className="px-4 py-2 bg-gray-50 border-b border-gray-100 flex-shrink-0">
      <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Audit Trail</p>
    </div>
    <div className="overflow-y-auto flex-1">
      {loading ? (
        <div className="p-6 text-center text-gray-400 text-sm">Loading...</div>
      ) : !data || data.length === 0 ? (
        <div className="p-6 text-center text-gray-400 text-sm">No changes recorded yet.</div>
      ) : (
        <table className="min-w-full text-sm divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              {['Date / Time', 'Changed By', 'Fields Changed', 'Reason'].map(h => (
                <th key={h} className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {data.map(entry => {
              const diffs = Object.keys(entry.new_values || {}).filter(
                k => JSON.stringify(entry.old_values?.[k]) !== JSON.stringify(entry.new_values?.[k])
              );
              return (
                <tr key={entry.id} className="hover:bg-gray-50 align-top">
                  <td className="px-3 py-2 whitespace-nowrap text-gray-500">
                    {new Date(entry.updated_at).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-gray-700">{entry.updated_by}</td>
                  <td className="px-3 py-2 text-gray-700">
                    {diffs.length === 0 ? (
                      <span className="text-gray-400 italic">—</span>
                    ) : (
                      <ul className="space-y-0.5">
                        {diffs.map(k => (
                          <li key={k}>
                            <span className="font-medium">{LABELS[k] || k}:</span>{' '}
                            <span className="text-red-500">{fmtVal(k, entry.old_values?.[k])}</span>
                            {' → '}
                            <span className="text-green-600">{fmtVal(k, entry.new_values?.[k])}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </td>
                  <td className="px-3 py-2 text-gray-500">{entry.reason || '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  </div>
);
